import React, { useState } from "react";
import ConfigurationModal from "./ConfigurationModal";
import MyIcon from "../Common/MyIcon";
import ImportIcon from "../../assets/icons/Icon_Library/application icons/general/import.svg2";
import SolutionImportModal from "./SolutionImportModal";
import SolutionPurchaseModal from "./SolutionPurchaseModal";
import ConfigurationIcon from "../../assets/icons/Icon_Library/application icons/monitoring/configuration-01.svg2";
import PurchaseIcon from "../../assets/icons/Icon_Library/application icons/reports/billing.svg2";
import { Modal } from "react-bootstrap";
import { SolutionType } from "../store/slices/settingsSlice";

export default function SolutionOptionsModal({
  solution: p,
}: {
  solution: SolutionType;
}) {
  const [show, setShow] = useState<boolean>(false);
  return (
    <>
      <button className="btn" onClick={() => setShow(true)}>
        {
          // eslint-disable-next-line no-nested-ternary
          p.ClientSolutions?.length ? (
            p.ClientSolutions[0].WasDeployed ? (
              <div className="d-flex align-items-center">
                <MyIcon Icon={ConfigurationIcon} width={20} />
                <span className="text-navy fw-bold ms-1">Configure</span>
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <MyIcon Icon={ImportIcon} width={23} className="rounded-3" />
                <span className="text-navy fw-bold ms-1">Deploy</span>
              </div>
            )
          ) : (
            <div className="d-flex align-items-center">
              <MyIcon Icon={PurchaseIcon} width={23} className="rounded-3" />
              <span className="text-navy fw-bold ms-1">Purchase</span>
            </div>
          )
        }
      </button>
      <Modal show={show} onHide={() => setShow(false)} size={"xxl"}>
        <Modal.Header closeButton onHide={() => setShow(false)}>
          <Modal.Title>
            {
              // eslint-disable-next-line no-nested-ternary
              p.ClientSolutions?.length
                ? p.ClientSolutions[0].WasDeployed
                  ? "Configure Solution"
                  : "Deploy Solution"
                : "Purchase Solution"
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-solution">
            {
              // eslint-disable-next-line no-nested-ternary
              p.ClientSolutions?.length ? (
                <SolutionImportModal
                  solutionClientUuid={p.ClientSolutions[0].Uuid}
                  setShow={setShow}
                />
              ) : (
                <SolutionPurchaseModal solution={p} />
              )
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
